/* eslint-disable import/no-unresolved */
import VerifyCustomerByOTP from "src/components/VerifyCustomer";
import { EInsurerType } from "src/helpers/FormDetails/ProposalDetails/interfaces";
import Header from "src/shared/Header";

function VerifyCustomerPage() {
  return (
    <div>
      <Header isEnable={false} />
      <VerifyCustomerByOTP insurerType={EInsurerType.PRIMARY} />
    </div>
  );
}

export default VerifyCustomerPage;
